import PageGame from '@/components/PageGame';

export default PageGame;

export async function getStaticProps() {
  return {
    props: {
      path: '/lotto-6aus49/spielen',
      game: 'Lotto6aus49',
      description:
        'LOTTO 6aus49 online spielen am Mittwoch & Samstag ✓: Lottozahlen tippen und sicher bei Ihrer Landeslotteriegesellschaft abgeben!',
      gameLotto6aus49: 'standard',
      seoDescription:
        'Ihr LOTTO 6aus49 Spielschein für Samstag und Mittwoch: Lottozahlen individuell oder per Quick-Tipp ankreuzen. Zusatzlotterien, Ziehungen, Laufzeit wählen und LOTTO online bei Ihrer Landeslotteriegesellschaft spielen.',
      title: 'LOTTO spielen ► Samstag & Mittwoch',
      seoHeadline: 'LOTTO 6aus49 | LOTTO.de - Spielen beim Original!',
    },
  };
}
